import { atom } from 'recoil';

export const ArchImgUrl = atom({
    key: 'RI002O-ArchImgUrl',
    default: undefined,
});

export const isExpandArchDiagram = atom({
    key: 'RI002O-isExpandArchDiagram',
    default: false,
});

export const OrderPayload = atom({
    key: 'RI002O-OrderPayload',
    default: {
        catalogCode: null,
        projectId: null,
        projectDetails: null,
        businessUnit: null,
        sector: null,
        program: null,
        division: null,
        environment: null,
        dataClassification: null,
        budgetCode: null,
        budgetCodeDetails: null,
        billingInfo: null,
        nonPrivilegedADGroupList: [{ readerValue: '' }],
        // privilegedADGroupList: [{ contributorValue: '' }],
        environmentDetails: null,
        adGroup: 'Yes',
        // privilegedADGroup: null,
        nonPrivilegedADGroup: null,
        businessAppService: 'No',
        businessApp: null,
        appService: null,
        isTouched: false,
        estimatedCost: null,
        appOwner: null,
        appOwnerDetails: null,
        // certificateOwnerOne: null,
        // certificateOwnerOneDetails: null,
        // certificateOwnerTwo: null,
        // certificateOwnerTwoDetails: null,
        adCertGroup: null,
        businessContact: null,
        businessContactDetails: null,
        // privilegedADGroupOwner: null,
        // privilegedADGroupOwnerDetails: null,
        nonPrivilegedADGroupOwner: null,
        nonPrivilegedADGroupOwnerDetails: null,
        applicationName: null,
        appShortName: null,
        isaNumber: null,
        iteAppService: null,
        appSupportMailId: null,
        resourceMgmt: null,
        isExternal: 'No',
    },
});

export const isGetAppShortNameLoading = atom({
    key: 'RI002O-isGetAppShortNameLoading',
    default: false,
});

export const isAppNameValid = atom({
    key: 'RI002O-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'RI002O-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'RI002O-isAppShortNameExist',
    default: false,
});

export const isBusinessNameValid = atom({
    key: 'RI002O-isBusinessNameValid',
    default: true,
});

export const isBudgetCodeValid = atom({
    key: 'RI002O-isBudgetCodeValid',
    default: true,
});

export const budgetCodeValidationModal = atom({
    key: 'RI002O-budgetCodeValidationModal',
    default: { open: false, budgetCode: '' },
});

export const isBillingInfoValid = atom({
    key: 'RI002O-isBillingInfoValid',
    default: true,
});

export const isProjectIdValid = atom({
    key: 'RI002O-isProjectIdValid',
    default: false,
});

export const adGroupErrorMsg = atom({
    key: 'RI002O-adGroupErrorMsg',
    default: false,
});

export const contributorErrorMsg = atom({
    key: 'RI002O-contributorErrorMsg',
    default: false,
});

export const isADGroupValid = atom({
    key: 'RI002O-isADGroupValid',
    default: true,
});

export const isBusinessAppValid = atom({
    key: 'RI002O-isBusinessAppValid',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'RI002O-isAppUrlValid',
    default: false,
});

export const isAppContextPathValid = atom({
    key: 'RI002O-isAppContextPathValid',
    default: false,
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'RI002O-isNonPrivilegedADGroupValid',
    default: false,
});

export const isPrivilegedADGroupValid = atom({
    key: 'RI002O-isPrivilegedADGroupValid',
    default: false,
});

export const costEstimateState = atom({
    key: 'RI002O-costEstimateState',
    default: null,
});

export const toggleModal = atom({
    key: 'RI002O-toggleModal',
    default: {
        isADGroupModalOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isPrivilegedADGroupOpen: false,
        isCost: { costType: '', isCostOpen: false },
    },
});

export const showPreviewOrder = atom({
    key: 'RI002O-showPreviewOrder',
    default: false,
});

export const previewDetails = atom({
    key: 'RI002O-previewdetails',
    default: null,
});
export const previewApiLoading = atom({
    key: 'RI002O-previewApiLoading',
    default: false,
});
export const isSectorDisabled = atom({
    key: 'RI002O-isSectorDisabled',
    default: true,
});
export const isBusinessUnitDisabled = atom({
    key: 'RI002O-isBusinessUnitDisabled',
    default: true,
});
export const isHcodeDisabled = atom({
    key: 'RI002O-isHcodeDisabled',
    default: true,
});
export const previewOrderError = atom({
    key: 'RI002O-previewError',
    default: {
        isPreviewError: false,
        message: '',
    },
});

export const isValidappSupportMailId = atom({
    key: 'RI002O-isValidappSupportMailId',
    default: false,
});
export const isValidOwners = atom({
    key: 'RI002O-isValidOwners',
    default: {
        isvalidAppOwner: true,
        isvalidCertificateOwnerOne: true,
        isvalidCertificateOwnerTwo: true,
    },
});
export const componentGroupsState = atom({
    key: 'RI002O-componentGroupsState',
    default: null,
});

export const SecondaryApprover = atom({
    key: 'RI002O-secondaryApprover',
    default: { selectedFieldFrom: { module: null, subModule: null }, value: { groupOwner: null, groupOwnerDetails: null } },
});

export const isValidISANumber = atom({
    key: 'RI002O-isValidISANumber',
    default: false,
});
